import {
  EmailOutlined,
  LocationOnOutlined,
  PhoneInTalkOutlined,
} from "@mui/icons-material";

export const contactInfoMock = [
  {
    title: "Location",
    info: "Berlin, Germany",
    icon: (
      <LocationOnOutlined
        color="primary"
        sx={{
          fontSize: { md: 40, xs: 36 },
        }}
      />
    ),
  },
  {
    title: "Call Us ",
    info: "+49 162 7344423‬",
    icon: (
      <PhoneInTalkOutlined
        color="primary"
        sx={{
          fontSize: { md: 40, xs: 36 },
        }}
      />
    ),
  },
  {
    title: "Mail Us ",
    info: "contact@svenbadalyan.com",
    icon: (
      <EmailOutlined
        color="primary"
        sx={{
          fontSize: { md: 40, xs: 36 },
        }}
      />
    ),
  },
];
